module.exports = __webpack_public_path__ + "img/card-content-6.a214cafa.png";